import ReportInfoBoxes from './ReportInfoBoxes';

export default ReportInfoBoxes;
